import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close menu on scroll
  useEffect(() => {
    if (isMobileMenuOpen) {
      const handleScroll = () => setIsMobileMenuOpen(false);
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isMobileMenuOpen]);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'El Ritual',
    href: '#ritual'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Galería',
    href: '#galeria'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Ubicación',
    href: '#ubicacion'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  const handleNavClick = (href: string) => {
    setIsMobileMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-black/95 backdrop-blur-sm py-3 shadow-lg shadow-black/50' : 'bg-transparent py-5'}`} data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="flex justify-between items-center" data-id="element-148">
          {/* Logo */}
          <a href="#" className="flex-shrink-0" data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/qVVJXV3u6YvRBr3F6qx2T7/logodeluxbarber.png" alt="Barbershop Delux Cut Logo" className="h-12 md:h-16 object-contain" data-id="element-150" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-151">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-delux-body hover:text-delux-gold transition-colors font-body text-sm uppercase tracking-wider relative group" data-id="element-152">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-delux-gold transition-all duration-300 group-hover:w-full" data-id="element-153"></span>
              </a>)}
            <a href="#contacto" className="bg-delux-gold hover:bg-delux-gold-light text-delux-bg px-6 py-2.5 rounded font-heading font-bold tracking-wide transition-all duration-300 hover:shadow-[0_0_15px_rgba(200,164,90,0.4)]" data-id="element-154">
              Reservar Ahora
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="lg:hidden text-delux-gold p-1" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-155">
            {isMobileMenuOpen ? <X size={28} data-id="element-156" /> : <Menu size={28} data-id="element-157" />}
          </button>
        </div>
      </div>

      {/* Mobile Accordion Dropdown */}
      <AnimatePresence data-id="element-158">
        {isMobileMenuOpen && <motion.nav initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="lg:hidden overflow-hidden border-t border-delux-gold/20 mt-3" data-id="element-159">
            <div className="bg-black/95 backdrop-blur-sm px-4 py-4 space-y-1" data-id="element-160">
              {navLinks.map((link, index) => <motion.div key={link.name} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.06,
            duration: 0.3
          }} data-id="element-161">
                  <button onClick={() => handleNavClick(link.href)} className="w-full text-left py-3 px-4 rounded-lg text-delux-body hover:text-delux-gold hover:bg-delux-gold/5 transition-all font-heading text-lg tracking-wide flex items-center justify-between group" data-id="element-162">
                    <span data-id="element-163">{link.name}</span>
                    <span className="text-delux-gold/40 group-hover:text-delux-gold transition-colors text-sm" data-id="element-164">
                      &rsaquo;
                    </span>
                  </button>
                  {index < navLinks.length - 1 && <div className="h-px bg-delux-gold/10 mx-4" data-id="element-165" />}
                </motion.div>)}

              {/* CTA Button */}
              <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: navLinks.length * 0.06,
            duration: 0.3
          }} className="pt-3" data-id="element-166">
                <button onClick={() => handleNavClick('#contacto')} className="block w-full text-center bg-delux-gold text-delux-bg px-6 py-3 rounded-lg font-heading font-bold tracking-wide" data-id="element-167">
                  Reservar Ahora
                </button>
              </motion.div>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}